import { render, staticRenderFns } from "./TodoView.vue?vue&type=template&id=1be80f06&scoped=true&"
import script from "./TodoView.vue?vue&type=script&lang=js&"
export * from "./TodoView.vue?vue&type=script&lang=js&"
import style0 from "./TodoView.vue?vue&type=style&index=0&id=1be80f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be80f06",
  null
  
)

export default component.exports